export enum permissionType {
    READ="READ",
    READ_WRITE="READ_WRITE",
    NONE="NONE",
}